import { css } from "@emotion/react";
import { roundCornersShadowBorder } from "../../../../assets/styles/styles";

export const textareaCss = css`
  ${roundCornersShadowBorder()};
  width: 600px;
  max-width: 100%;
  margin-bottom: 10px;
  min-height: 50px;
`;
